import { BRAND, FOOTER_TAGLINE } from "@/content/site";
import logoUrl from "@/assets/logo-djinious-lab.png";

export function Footer() {
  return (
    <footer className="border-t border-border bg-surface">
      <div className="mx-auto flex max-w-6xl flex-col gap-3 px-6 py-12 text-sm text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
        <span className="flex items-center gap-2 font-extrabold tracking-tight text-foreground">
          <img src={logoUrl} alt="" className="h-6 w-6" width={24} height={24} />
          {BRAND}
        </span>
        <span className="max-w-md">{FOOTER_TAGLINE}</span>
      </div>
    </footer>
  );
}
